module.exports = __webpack_public_path__ + "static/media/Tablou1.9d45966b.webp";